import { render, staticRenderFns } from "./WorkgroupsPage.vue?vue&type=template&id=b21f62f0&"
import script from "./WorkgroupsPage.vue?vue&type=script&lang=js&"
export * from "./WorkgroupsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports